import { apiClient } from "@/api/apiClient"
import type { ApiResultPromise } from "@/api/errors"

// The browser-measured Web Vitals we report. Mirrors
// PrometheusRegistry::WEB_VITAL_METRICS on the backend, which validates the
// value against a fixed allowlist before touching any metric.
export type WebVitalMetric = "lcp" | "inp" | "cls" | "fcp" | "ttfb"

// The `web-vitals` library's performance bucket, derived from Google's
// thresholds. Mirrors PrometheusRegistry::WEB_VITAL_RATINGS.
export type WebVitalRating = "good" | "needs-improvement" | "poor"

export interface WebVitalReport {
  metric: WebVitalMetric
  // Milliseconds for the timing vitals (lcp/inp/fcp/ttfb); a unitless layout
  // shift score for cls.
  value: number
  rating: WebVitalRating
}

export const WEB_VITALS_PATH = "/api/web-vitals"

// Beacons a single Web Vital sample to the backend Prometheus counter/
// histograms so real-user client-side performance is chartable in Grafana.
// Fire-and-forget: telemetry must never surface to the user, so a failed
// beacon is returned as a typed error for the caller to log without any UI.
export async function beaconWebVital(report: WebVitalReport): ApiResultPromise<void> {
  return apiClient.post<void>(WEB_VITALS_PATH, "Failed to beacon web vital", report)
}
